import React from 'react';
import { Link } from 'react-router-dom';
import { profile, focusAreas } from '../data';
import MediumFeed from '../components/MediumFeed';

const FocusIcon = ({ name }) => {
  const common = { width: 20, height: 20, fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' };
  switch (name) {
    case 'signal':
      return (
        <svg viewBox="0 0 24 24" {...common}><path d="M2 20h.01"/><path d="M7 20v-4"/><path d="M12 20v-8"/><path d="M17 20V8"/><path d="M22 4v16"/></svg>
      );
    case 'code':
      return (
        <svg viewBox="0 0 24 24" {...common}><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>
      );
    case 'ai':
      return (
        <svg viewBox="0 0 24 24" {...common}><circle cx="12" cy="12" r="3"/><path d="M12 2v4"/><path d="M12 18v4"/><path d="M4.93 4.93l2.83 2.83"/><path d="M16.24 16.24l2.83 2.83"/><path d="M2 12h4"/><path d="M18 12h4"/><path d="M4.93 19.07l2.83-2.83"/><path d="M16.24 7.76l2.83-2.83"/></svg>
      );
    case 'chip':
      return (
        <svg viewBox="0 0 24 24" {...common}><rect x="4" y="4" width="16" height="16" rx="2"/><rect x="9" y="9" width="6" height="6"/><path d="M9 2v2"/><path d="M15 2v2"/><path d="M9 20v2"/><path d="M15 20v2"/><path d="M2 9h2"/><path d="M2 15h2"/><path d="M20 9h2"/><path d="M20 15h2"/></svg>
      );
    default:
      return null;
  }
};

const Home = () => {
  return (
    <div className="page-content">
      <section className="hero">
        <div className="eyebrow"><span className="dot" /> AVAILABLE FOR INTERESTING CONVERSATIONS</div>
        <h1>
          Hi, I'm {profile.name.split(' ')[0]}. <br />
          I work at the edge of <span className="grad">5G, 6G & AI</span>.
        </h1>
        <p>{profile.about}</p>
        <div className="cta-row">
          <Link className="btn btn-primary" to="/posts">
            Read my posts
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
          </Link>
          <a className="btn" href={profile.socials.youtube} target="_blank" rel="noopener noreferrer">
            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 0 0 .5 6.2 31.4 31.4 0 0 0 0 12a31.4 31.4 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 0 0 2.1-2.1 31.4 31.4 0 0 0 .5-5.8 31.4 31.4 0 0 0-.5-5.8zM9.6 15.6V8.4l6.3 3.6-6.3 3.6z"/></svg>
            Watch on YouTube
          </a>
        </div>
      </section>

      <section className="section">
        <div className="section-head">
          <div>
            <div className="label">{'// FOCUS AREAS'}</div>
            <h2>What I work on</h2>
          </div>
        </div>
        <div className="grid grid-3">
          {focusAreas.map((f) => (
            <div className="card" key={f.title}>
              <div className="icon"><FocusIcon name={f.icon} /></div>
              <h3>{f.title}</h3>
              <p>{f.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="section-head">
          <div>
            <div className="label">{'// LATEST FROM MEDIUM'}</div>
            <h2>Recent posts</h2>
          </div>
          <Link to="/posts">All posts →</Link>
        </div>
        <MediumFeed limit={3} />
      </section>

      <section className="section">
        <div className="section-head">
          <div>
            <div className="label">{'// VIDEO'}</div>
            <h2>On YouTube</h2>
          </div>
        </div>
        <a className="yt-cta" href={profile.socials.youtube} target="_blank" rel="noopener noreferrer">
          <div className="yt-icon">
            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 0 0 .5 6.2 31.4 31.4 0 0 0 0 12a31.4 31.4 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 0 0 2.1-2.1 31.4 31.4 0 0 0 .5-5.8 31.4 31.4 0 0 0-.5-5.8zM9.6 15.6V8.4l6.3 3.6-6.3 3.6z"/></svg>
          </div>
          <div className="yt-text">
            <h3>@devika_ajith</h3>
            <p>Talks, tutorials, and behind-the-scenes from the world of telecom and AI. Subscribe for new videos.</p>
          </div>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
        </a>
      </section>
    </div>
  );
};

export default Home;
